var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFonts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 13.3337L5.33333 5.33366C5.33333 3.86699 6.53333 2.66699 8 2.66699C9 2.66699 9.86667 3.20033 10.3333 4.00033M4 8.00033H6.66667M9.33333 8.00033H10.6667L10.6667 13.3337M4 13.3337H6.66667M9.33333 13.3337L12 13.3337",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFonts);
export default __webpack_public_path__ + "static/media/fonts.6533f83a8efaa2e243fe443596edd471.svg";
export { ForwardRef as ReactComponent };